/** Domains used when dispatching normalized cable events (extend as channels are added). */
export const REALTIME_DOMAINS = {
  ALERT: "alert",
  CHAT: "chat",
  PRESENCE: "presence",
  WILDCARD: "*",
};

export const WS_TICKET_PATH = "/ws-ticket/";
